import { useTranslations } from 'next-intl'
import { LEGGING_LENGTH_GUIDE } from '../../../../../../lib/constants/size'

export const GuideLegging = () => {
  const data = LEGGING_LENGTH_GUIDE
  const t = useTranslations()

  return (
    <div className='mt-5 text-sm'>
      <div className='flex h-12 items-center bg-neutral-500 px-4 py-1 font-criteria text-base text-white'>
        {t(data.title)}
      </div>

      <div className='w-full overflow-x-auto'>
        <table className='w-full border border-neutral-200'>
          <thead>
            <tr className='border-b border-neutral-200'>
              <th className='sticky left-0 min-w-40 bg-white p-4 text-left font-bold text-neutral-900'>
                {t(data.headerRow)}
              </th>
              {data.columns.map((column) => (
                <th
                  key={column.id}
                  className='min-w-24 p-4 text-center font-bold text-neutral-900'
                >
                  {t(column.name)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row) => (
              <tr key={row.id} className='border-b border-neutral-200'>
                <td className='sticky left-0 bg-white p-4 text-left font-bold text-neutral-900'>
                  {t(row.name)}
                </td>
                {data.columns.map((column) => {
                  const cellData = data.matrix.find(
                    (m) => m.rowId === row.id && m.columnId === column.id
                  )
                  return (
                    <td
                      key={column.id}
                      className='p-4 text-center text-neutral-900'
                    >
                      {cellData?.value || ''}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className='my-4 text-sm text-neutral-600'>{t(data.note)}</p>

      <div>
        {data.descriptions.map((item, index) => (
          <p key={index} className='text-sm text-neutral-800'>
            <strong>{item.type}:</strong> {t(item.description)}
          </p>
        ))}
      </div>
    </div>
  )
}
